// Opens the rendered debit note in a new window and triggers the browser's
// print dialog — "Save as PDF" there produces a real file with no extra
// dependency (jsPDF, etc.). The app's own stylesheets are copied across so the
// printout is the preview, class for class, rather than a second template that
// drifts from it.
const waitForStylesheets = (doc) => Promise.all(
    [...doc.querySelectorAll("link[rel='stylesheet']")].map((link) => (link.sheet
        ? Promise.resolve()
        : new Promise((resolve) => {
            link.addEventListener("load", resolve, { once: true });
            link.addEventListener("error", resolve, { once: true });
        })))
);

/**
 * @param node the rendered document element
 * @param title window title, which browsers use as the default file name
 * @returns false when the pop-up was blocked
 */
export const printDebitNote = (node, title) => {
    if (!node) return false;

    const printWindow = window.open("", "_blank", "width=900,height=1000");
    if (!printWindow) return false;

    const styles = [...document.querySelectorAll("link[rel='stylesheet'], style")]
        .map((el) => el.outerHTML)
        .join("");

    printWindow.document.open();
    printWindow.document.write(`<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<base href="${window.location.origin}/" />
<title>${title.replace(/</g, "&lt;")}</title>
${styles}
<style>
    body { margin: 0; padding: 32px; background: #fff; }
    @media print { body { padding: 0; } }
</style>
</head>
<body>${node.outerHTML}</body>
</html>`);
    printWindow.document.close();

    // In a production build the styles are <link>s, which load after write()
    // returns — printing before then would give an unstyled page.
    waitForStylesheets(printWindow.document).then(() => {
        printWindow.focus();
        printWindow.print();
    });

    return true;
};
